import { render } from "./MobileSurvey.vue?vue&type=template&id=4763c49f&scoped=true"
import script from "./MobileSurvey.vue?vue&type=script&lang=js"
export * from "./MobileSurvey.vue?vue&type=script&lang=js"

import "./MobileSurvey.vue?vue&type=style&index=0&id=4763c49f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4763c49f"]])

export default __exports__